/**
 * Sanitize the type to be used as a key for the page filters
 * @param {string} type
 * @param {string} workspace
 * @returns {string}
 */
export const getPageKey = ({ type, workspace }) => {
  if (type === 'Report' && workspace !== 'Reports') {
    type = 'Automated report';
  }
  return `${type.trim().toLowerCase().replace(/\s+/g, '_')}_filters`;
};

/**
 * Returns the list page search placeholder text based on the workspace
 * @param {string} workspace
 * @returns {string}
 */
export const searchPlaceholderText = (workspace) => {
  if (workspace === 'Reports') {
    return 'Search by report name, report answer, or creator';
  } else if (workspace === 'FastTracks') {
    return 'Search by Narrative name, creator, or answers';
  } else {
    return 'Search by name or creator';
  }
};
